import React from 'react';
import classNames from 'classnames';

import Icon, { IconNames } from './presenter';

import { iconDefaultProps, iconPropTypes } from './iconPropTypes';


const UploadIcon = ({ className, size, ...rest }) => (
  <Icon
    className={classNames({
      'j-upload-icon': true,
      [className]: className,
    })}
    name={IconNames.UPLOAD}
    size={size}
    {...rest}
  />
);

UploadIcon.propTypes = {
  ...iconPropTypes,
};

UploadIcon.defaultProps = {
  ...iconDefaultProps,
};


export default UploadIcon;
